import { connect } from 'react-redux';
import ScribeLoginProfiling from './ScribeLoginProfiling';

import { fetchUserProfile } from '../../actions';

const mapStateToProps = state => ({
  firebaseUser: state.firebase.user,
});

export default connect(mapStateToProps, { fetchUserProfile })(ScribeLoginProfiling);
